import { NgModule } from '@angular/core';
import { MatButtonLoadingDirective } from './mat-button-loading.directive';
import { DzDirective } from './dz.directive';
import { OptionsScrollDirective } from './options-scroll.directive';
import { TableStickyHeaderDirective } from './table-sticky-header.directive';
import { UpgradeBadgeDirective } from './upgrade-badge.directive';
import { UpgradeButtonDirective } from './upgrade-button.directive';
import { AutofocusDirective } from './autofocus.directive';

@NgModule({
  declarations: [MatButtonLoadingDirective, OptionsScrollDirective, DzDirective, TableStickyHeaderDirective, UpgradeBadgeDirective,
    UpgradeButtonDirective, AutofocusDirective],
  exports: [MatButtonLoadingDirective, OptionsScrollDirective, DzDirective, TableStickyHeaderDirective, UpgradeBadgeDirective,
    UpgradeButtonDirective, AutofocusDirective]
})
export class EeDirectivesModule {}
